import { useMemo } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import Icon from 'components/Icon';
import { PiiTypeList } from 'components/PiiType';
import SensitivityChip from 'components/SensitivityChip';
import GridCell from 'components/table/GridCell';
import GridRow from 'components/table/GridRow';
import { Tooltip } from 'components/Tooltip';
import { Typo } from 'components/typography/Typo';
import { AssetGroupDataFlowTableItem } from 'models/assetsGroupsDataFlows/dto';
import { lastSeen } from 'services/lastSeen';
import { PATHS } from 'services/router';
import DataFlowIcon from 'views/SuperAssets/DataFlowIcon';
import styles from '../index.module.css';

type Props = {
	dataFlow: AssetGroupDataFlowTableItem;
};

function DataFlowTableItem({ dataFlow }: Props) {
	const {
		flow_direction,
		interacts_with,
		groupId,
		name,
		sensitivity,
		data_types,
		last_seen,
		is_encrypted,
		is_mesh_network,
	} = dataFlow;
	const history = useHistory();
	const lastSeenValue = useMemo(() => lastSeen({ timestamp: last_seen, short: true }), [last_seen]);

	function onRowClick() {
		const path = generatePath(PATHS.ASSET_GROUP_ITEM, {
			tab: 'data-flows',
			details_with: interacts_with,
			id: groupId,
			flow_direction,
		});
		history.replace(path + history.location.search);
	}

	return (
		<GridRow
			className={styles.rowContainer}
			onClick={onRowClick}
			hover
			border
			data-test="data-flow-table-row"
		>
			<GridCell className={styles.directionAndTls} withoutBlur>
				<DataFlowIcon direction={flow_direction} className={styles.icon} />
				<div className={styles.gapCell}>
					{is_encrypted && <Icon name="tlsRegular" dataTest="tls-icon" />}
					{is_mesh_network && <Icon name="MeshNetwork/Regular" dataTest="mesh-network-icon" />}
				</div>
			</GridCell>

			<GridCell className={styles.gapCell}>
				<Typo variant="D/Medium/Body-S">{name}</Typo>
			</GridCell>

			<GridCell>
				<SensitivityChip sensitivity={sensitivity} />
			</GridCell>

			<GridCell>
				<PiiTypeList data={data_types} />
			</GridCell>

			<GridCell>
				<Tooltip title={lastSeenValue.date}>{lastSeenValue.diff}</Tooltip>
			</GridCell>
		</GridRow>
	);
}

export default DataFlowTableItem;
